import { actions } from './express/actions'
import { getters } from './express/getters'
import { state } from './express/state'
import { mutations } from './express/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
